// Redux Toolkit slice for the Data Integrity dialog
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  open: false,
  // holds the selected row / meter integrity object
  row: null,
};

const dataIntegritySlice = createSlice({
  name: 'dataIntegrity',
  initialState,
  reducers: {
    openDialog(state, action) {
      state.open = true;
      if (action.payload) state.row = action.payload; // pass the meter integrity object
    },
    closeDialog(state) {
      state.open = false;
    },
    setRow(state, action) {
      state.row = action.payload;
    },
    setOpen(state, action) {
      state.open = !!action.payload;
    },
    reset(state) {
      state.open = false;
      state.row = null;
    },
  },
});

export const { openDialog, closeDialog, setRow, setOpen, reset } =
  dataIntegritySlice.actions;

export const selectDataIntegrityState = (state) => state.dataIntegrity;
export const selectDataIntegrityOpen = (state) => state.dataIntegrity.open;
export const selectDataIntegrityRow = (state) => state.dataIntegrity.row;

export default dataIntegritySlice.reducer;
